import { Handle } from 'hast-util-to-mdast'

export const comment: Handle = (_h, _node) => {
  return undefined
}
